import React from "react";
import "./app.scss";
import Header from "./header/Header";
import { Router, Route } from "react-router-dom";
import SectionFilter from "../components/sectionfilter/SectionFilter";
import JobsSection from "../components/jobssection/JobsSection";
import JobDescription from "../components/jobdescription/JobDescription";
import history from "./history";
import { connect } from "react-redux";

class App extends React.Component {
  render() {
    // if (this.props.darkMode) {

    // } else {
    //   document.body.classList.remove("dark");
    // }
    return (
      <React.Fragment>
        <Router history={history}>
          <Header />
          <Route path="/" exact component={SectionFilter} />
          <Route path="/" exact component={JobsSection} />
          <Route path="/jobs/:id" exact component={JobDescription} />
        </Router>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    darkMode: state.darkMode,
  };
};

export default connect(mapStateToProps)(App);
